/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */

/**
 * @type {number}
 */
const HIDE_MENU_TIMEOUT = 150;

/**
 * @type {number}
 */
const SHOW_MENU_TIMEOUT = 150;

/**
 * @type {string}
 */
const MENU_ITEM_SELECTOR = '.menu-item';

/**
 * @type {string}
 */
const DROPDOWN_MENU_ITEM_SELECTOR = '.dropdown-menu-item';

/**
 * @type {string}
 */
const ACTIVE_MENU_PREFIX = 'active-menu-';

export default class {
    /**
     * @param {jQuery} $header
     */
    constructor($header) {
        this.$header = $header;
        this.currentMenuIndex = null;
        this.$menuItemContent = $('.menu-item-content');
        this.$statusHeader = $('#status-header');
        this.hideMenuTimer = null;
    }

    init() {
        let showMenuTimer = null;

        this.$header.on('mouseenter', MENU_ITEM_SELECTOR + DROPDOWN_MENU_ITEM_SELECTOR, e => {
            const $currentMenu = $(e.currentTarget);

            if (this.currentMenuIndex !== null) {
                this._showMenu($currentMenu);
            } else {
                showMenuTimer = setTimeout(() => {
                    this._showMenu($currentMenu);
                }, SHOW_MENU_TIMEOUT);
            }
        });

        this.$header.on('mouseenter', MENU_ITEM_SELECTOR + ':not(' + DROPDOWN_MENU_ITEM_SELECTOR + ')', () => {
            clearTimeout(this.hideMenuTimer);
            clearTimeout(showMenuTimer);
            this._hideMenu();
        });

        this.$header.on('mouseleave', MENU_ITEM_SELECTOR + DROPDOWN_MENU_ITEM_SELECTOR, () => {
            clearTimeout(showMenuTimer);
            this.hideMenuTimer = setTimeout(this._hideMenu.bind(this), HIDE_MENU_TIMEOUT);
        });

        this.$menuItemContent.on('mouseenter', () => {
            clearTimeout(this.hideMenuTimer);
            clearTimeout(showMenuTimer);
        });

        this.$menuItemContent.on('mouseleave', () => {
            clearTimeout(showMenuTimer);
            this.hideMenuTimer = setTimeout(this._hideMenu.bind(this), HIDE_MENU_TIMEOUT);
        });

        $('.body-overlay').on('click', () => {
            clearTimeout(this.hideMenuTimer);
            clearTimeout(showMenuTimer);
            this._hideMenu();
        });
    }

    _removeOverlay() {
        this.$header.removeClass('hovered');
    }

    _addOverlay() {
        this.$header.addClass('hovered');
    }

    _hideMenu() {
        if (this.currentMenuIndex === null) {
            return;
        }

        this._removeOverlay();
        this.$menuItemContent.filter('.menu-item-content-' + this.currentMenuIndex).css('top', '-450px');
        this.$header.removeClass(ACTIVE_MENU_PREFIX + this.currentMenuIndex);
        this.currentMenuIndex = null;
    }

    /**
     * @param {jQuery} $currentMenu
     */
    _showMenu($currentMenu) {
        clearTimeout(this.hideMenuTimer);
        this._hideMenu();
        this._addOverlay();
        this.currentMenuIndex = $currentMenu.data('menu-index');
        this.$header.addClass(ACTIVE_MENU_PREFIX + this.currentMenuIndex);
        let headerHeight = this.$header.outerHeight() + (this.$statusHeader.is(':visible') ? this.$statusHeader.outerHeight() : 0);
        this.$menuItemContent.filter('.menu-item-content-' + this.currentMenuIndex).css('top', headerHeight);
    }
}
